import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Container, Grid, Typography, Box,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import img from '../assets/images/Vector2Up.svg';

const useStyles = makeStyles((theme) => ({
  firstContainer: {
    marginTop: '50px',
  },
  firstGridItem: {
    backgroundColor: '#175E82',
    padding: theme.spacing(2),
    height: '441px',
    borderRadius: '0px 30px 0px 0px',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  firstGridItemText: {
    color: '#FFF',
    fontFamily: 'Inter',
    fontSize: 40,
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '120%',
    textAlign: 'left',
    padding: '25px 140px 25px 25px',
  },
  secondGridItem: {
    paddingTop: '20px',
    backgroundColor: '#C7E3F8',
    padding: theme.spacing(2),
    height: '441px',
    borderRadius: '30px 0px 0px 30px',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  secondGridItemText: {
    color: '#2F4960',
    textShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    fontFamily: 'Inter',
    fontSize: 48,
    fontStyle: 'normal',
    fontWeight: '800',
    lineHeight: '120%',
    letterSpacing: '1.44px',
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
    },
  },
  buttonSearch: {
    display: 'flex',
    width: '615px',
    height: '60px',
    padding: '20px 40px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    flexShrink: 0,
    borderRadius: '600px',
    background: '#175E82',
    margin: '50px auto',
    [theme.breakpoints.down('sm')]: {
      width: '300px',
    },
  },
  buttonSearchText: {
    color: '#FFF',
    fontFamily: 'Inter',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '120%',
    letterSpacing: '0.4px',
    textTransform: 'uppercase',
  },
  navSections: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    margin: '10px auto 150px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  navButton: {
    width: '32%',
    display: 'flex',
    height: '70px',
    padding: '20px 40px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    borderRadius: '20px',
    background: '#FFF',
    '&:hover': {
      background: '#DEDEDE',
      boxShadow: '0px 0px 10px 0px rgba(49, 40, 63, 0.10)',
    },
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginBottom: '15px',
    },
  },
  navButtonText: {
    color: '#0A0A13',
    fontFamily: 'Inter',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: '0.2px',
    textTransform: 'uppercase',
  },
  navButtonImage: {
    paddingLeft: '50px',
  },
}));

export default function About() {
  const classes = useStyles();

  return (
    <Container maxWidth={false}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Box className={classes.firstContainer}>
            <Grid container spacing={1}>
              <Grid item sm={12} md={6}>
                <Box className={classes.secondGridItem}>
                  <Typography variant="h4" className={classes.secondGridItemText}>
                    Державний реєстр
                  </Typography>
                  <Typography variant="h4" className={classes.secondGridItemText}>
                    майнових об’єктів
                  </Typography>
                  <Typography variant="h4" className={classes.secondGridItemText}>
                    оздоровлення та
                  </Typography>
                  <Typography variant="h4" className={classes.secondGridItemText}>
                    відпочинку дітей
                  </Typography>
                  <NavLink
                    to="/mop/search"
                    style={{ textDecoration: 'none' }}
                    className={classes.buttonSearch}
                    activeStyle={{
                      border: '1px solid #fff',
                    }}
                  >
                    <span
                      className={classes.buttonSearchText}
                      role="button"
                    >
                      Пошук закладу
                    </span>
                  </NavLink>
                </Box>
              </Grid>
              <Grid item sm={12} md={6}>
                <Box className={classes.firstGridItem}>
                  <Typography variant="h4" className={classes.firstGridItemText}>
                    Створений з метою забезпечення доступності та відкритості інформації про дитячі заклади оздоровлення та відпочинку дітей і послуги, які вони надають
                  </Typography>
                </Box>
              </Grid>

            </Grid>
          </Box>
        </Grid>
      </Grid>
      <div className={classes.navSections}>
        <NavLink
          to="/mop/search"
          style={{ textDecoration: 'none' }}
          className={classes.navButton}
        >
          <span
            className={classes.navButtonText}
            role="button"
          >
            Пошук закладу
            <img src={img} className={classes.navButtonImage} alt="arrow" />
          </span>

        </NavLink>
        <NavLink
          to="/mop/lawbase"
          style={{ textDecoration: 'none' }}
          className={classes.navButton}
        >
          <span
            className={classes.navButtonText}
            role="button"
          >
            Законодавство
            <img src={img} className={classes.navButtonImage} alt="arrow" />
          </span>

        </NavLink>
        <NavLink
          to="/mop/contacts"
          style={{ textDecoration: 'none' }}
          className={classes.navButton}
        >
          <span
            className={classes.navButtonText}
            role="button"
          >
            контакти
            <img src={img} className={classes.navButtonImage} alt="arrow" />
          </span>

        </NavLink>
      </div>

    </Container>
  );
}
